export enum EnumTipoDataControle {
  DataVerificacaoModoOffline = 0,
  DataVerificacaoListaLeis = 1,
  DataVisualizacaoNovidades = 2,
  DataVerificacaoCacheComentarios = 3,
  DataVerificacaoCacheReferencias = 4,
  DataVerificacaoCacheGrifos = 5,
  DataVerificacaoCacheEstatisticas = 6,
  DataVerificacaoCacheComentariosGerenciados = 7,
  DataVerificacaoCacheReferenciasGerenciados = 8,
}
